export default Object.freeze({
  CHOOSE_USER: 1,
  CREATE_SUBSCRIBER: 2,
  CREATE_ASSISTED: 3,
  CREATE_SUBSCRIPTION: 4,
  FILL_PAYMENT_INFO: 5,
});
